import React, { useState, useEffect } from 'react';
import Button from './Button';


const FloatingCTA = () => {
  const [isHeroVisible, setIsHeroVisible] = useState(true);
  const [isEndVisible, setIsEndVisible] = useState(false);

  useEffect(() => {
    const heroSection = document.getElementById('hero');
    // Support both /landing-page (#waitlist) and / (#join-waitlist) end-of-page sections.
    const endSection =
      document.getElementById('waitlist') ||
      document.getElementById('join-waitlist');

    if (!heroSection && !endSection) return undefined;

    const observer = new IntersectionObserver((entries) => {
      entries?.forEach((entry) => {
        if (entry?.target === heroSection) {
          setIsHeroVisible(entry?.isIntersecting);
        }
        if (entry?.target === endSection) {
          setIsEndVisible(entry?.isIntersecting);
        }
      });
    }, { threshold: 0 });

    if (heroSection) observer?.observe(heroSection);
    if (endSection) observer?.observe(endSection);

    return () => observer?.disconnect();
  }, []);

  // Show the floating CTA once the hero has scrolled out of view and before the
  // end-of-page CTA scrolls into view.
  const isVisible = !isHeroVisible && !isEndVisible;

  const handleClick = () => {
    window.open('https://depthme.app', '_blank', 'noopener,noreferrer');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Desktop Floating CTA */}
      <div className="hidden md:block fixed right-6 top-1/2 transform -translate-y-1/2 z-90">
        <div className="glassmorphism rounded-2xl p-6 max-w-xs">
          <div className="text-center space-y-4">
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">
                Don't let your inner critic win
              </p>
              <Button 
                variant="default" 
                size="sm"
                onClick={handleClick}
                className="w-full violet-glow"
                iconName="ArrowRight"
                iconPosition="right"
              >
                Open App
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Floating CTA */}
      <div
        className="md:hidden fixed left-4 right-4 z-90"
        style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)' }}
      >
        <div className="glassmorphism rounded-2xl p-4">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm text-muted-foreground">
              Transform your inner critic
            </p>

            <Button
              variant="default"
              size="sm"
              onClick={handleClick}
              className="violet-glow min-h-[44px]"
              iconName="ArrowUp"
              iconPosition="right"
            >
              Open App
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FloatingCTA;